module.exports = __webpack_public_path__ + "static/media/icon_help.0355213c.svg";